import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useRecoilState } from 'recoil'

import Footer from '@/shared/components/layout/Footer'
import MoHeader from '@/shared/components/layout/MoHeader'
import PcHeader from '@/shared/components/layout/PcHeader'
import SubTop from '@/shared/components/layout/SubTop'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { HeaderUserTab } from '@/shared/store'
import { LayoutSubPage, LayoutWrap } from '@/styles/common/layout'

const Layout = (props: { children: React.ReactNode }): JSX.Element => {
  const { pathname } = useLocation()
  const { width } = useWindowDimensions()
  const [UserTab, setUserTab] = useRecoilState(HeaderUserTab)

  useEffect(() => {
    window.scroll({ top: 0 })
  }, [pathname])

  return (
    <>
      <LayoutWrap onClick={() => UserTab && setUserTab(false)}>
        {width > 1200 ? <PcHeader /> : <MoHeader />}
        <SubTop />
        {pathname !== '/' ? <LayoutSubPage>{props.children}</LayoutSubPage> : <>{props.children}</>}
      </LayoutWrap>
      <Footer />
    </>
  )
}
export default Layout
